import { render, staticRenderFns } from "./OrderViewer.vue?vue&type=template&id=46888b47&scoped=true"
import script from "./OrderViewer.vue?vue&type=script&lang=js"
export * from "./OrderViewer.vue?vue&type=script&lang=js"
import style0 from "./OrderViewer.vue?vue&type=style&index=0&id=46888b47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46888b47",
  null
  
)

export default component.exports